import { ReactElement } from 'react';

import { PatientPresence } from '@dreryk/egabinet-appointment-frontend-api';

import {
   appendTestableElementAttributes,
   IconFillColor,
   NonWaitingIcon,
   StyledFlex,
   WaitingIcon,
} from '@dreryk/react-components';

import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';
import { calendarTranslationKeys } from '../../../../../../translations';

import { PatientPresenceStatusToggle } from './PatientPresenceStatusToggle';

const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab;

type PatientPresenceStatusInfoItemProps = {
   patientPresence: PatientPresence;
   appointmentId: number;
};

export const PatientPresenceStatusInfoItem = (props: PatientPresenceStatusInfoItemProps): ReactElement => {
   const patientPresent = props.patientPresence === 'PRESENT';
   return (
      <StyledFlex
         justifyContent={'space-between'}
         alignItems={'center'}
         {...appendTestableElementAttributes('patientPresenceStatus')}
      >
         <AppointmentDetailsInfoItem
            testId={'patientPresenceStatus'}
            icon={patientPresent ? <WaitingIcon /> : <NonWaitingIcon />}
            iconFillColor={patientPresent ? IconFillColor.SUCCESS : IconFillColor.BACKGROUND}
            content={patientPresent ? t.inWaitingRoom : t.notSpecified}
            description={t.presenceStatus}
         />
         <PatientPresenceStatusToggle initialPatientPresent={patientPresent} appointmentId={props.appointmentId} />
      </StyledFlex>
   );
};
